import React from "react";
import { Link } from "react-router-dom";
import { Container } from "@/components/layout/Container";
import { FOOTER } from "@/content/homeContent";
import stratoLogo from "@/assets/brand/strato-logo.png";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="dark border-t border-[color:rgba(255,255,255,0.10)] bg-strato-nearblack text-white"
    >
      <Container className="py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-3">
            <div className="flex items-center gap-2.5">
              <span
                aria-hidden
                className="grid h-9 w-9 place-items-center overflow-hidden rounded-md bg-white"
              >
                <img
                  src={stratoLogo}
                  alt="Strato Lab 3D"
                  className="h-7 w-7 object-contain"
                />
              </span>
              <span className="font-display text-[15px] font-semibold tracking-[-0.01em]">
                {FOOTER.wordmark}
              </span>
            </div>
            <p className="mt-4 max-w-[36ch] text-sm leading-[1.6] text-white/60">
              {FOOTER.tagline}
            </p>
            <p className="strato-micro mt-6 text-white/40">
              MADE IN ITALY · FDM · PLA
            </p>
          </div>

          {FOOTER.columns.map((col, ci) => (
            <div key={col.title} className="md:col-span-3">
              <p className="strato-micro text-white/45">{col.title}</p>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={`${ci}-${link.to}`}>
                    <Link
                      to={link.to}
                      data-testid={`footer-link-${ci}-${link.to.replace(/\//g, "") || "home"}`}
                      className="text-sm text-white/70 transition-colors duration-150 hover:text-white"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/45 sm:flex-row sm:items-center">
          <span>© {year} Strato Lab 3D. Tutti i diritti riservati.</span>
          <span className="strato-micro text-white/35">
            MADE IN ITALY · STAMPA 3D SU RICHIESTA
          </span>
        </div>
      </Container>
    </footer>
  );
};
